"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => ({
  wrapper: {
    flex: "0 0 100%"
  },
  button: {
    position: "relative"
  },
  isLocked: {
    paddingLeft: 48,
    "& svg": {
      left: 16,
      position: "absolute",
      width: 24
    }
  }
}));
var _default = exports.default = styles;